// useDebounce.js
import { useState, useEffect } from "react";

function UseDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler); // Cleanup if value changes within delay
  }, [value, delay]);

  return debouncedValue;
}

export default UseDebounce;
